import React from "react";

const Popup = ({ isVisible, onClose, content }) => {
  const metaItems = [
    { label: "Created By:", value: content?.createdBy },
    { label: "Date:", value: content?.date },
    { label: "Client:", value: content?.client },
    { label: "Categories:", value: content?.categories },
  ].filter((item) => item.value);

  return (
    <div className={`popup-wrap ${isVisible ? "visible" : ""}`}>
      <div className="popup-box transform-in">
        {content?.image ? (
          <img className="pop-up-img1" src={content.image} alt={content.title} />
        ) : null}
        <button
          type="button"
          className="close-btn popup-close"
          onClick={onClose}
          aria-label="Close"
        >
          <svg
            width="40px"
            height="40px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g strokeWidth="0"></g>
            <g strokeLinecap="round" strokeLinejoin="round"></g>
            <g>
              <path
                d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                stroke="#FFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M9.16998 14.83L14.83 9.17004"
                stroke="#FFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M14.83 14.83L9.16998 9.17004"
                stroke="#FFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </g>
          </svg>{" "}
        </button>
        <p className="corpo">{content?.title || "Portfolio"}</p>
        {content?.subtitle ? (
          <p className="corpo-sub">{content.subtitle}</p>
        ) : null}

        {metaItems.length > 0 ? (
          <div className="corporate_main">
            {metaItems.map((item) => (
              <div className="cuberto_main" key={item.label}>
                <p className="created_by">{item.label}</p>
                <p className="cuberto">{item.value}</p>
              </div>
            ))}
          </div>
        ) : null}

        {content?.description ? <p className="Ornare">{content.description}</p> : null}

        {content?.image2 ? (
          <div className="pop-up-img-section2">
            <img src={content.image2} alt={`${content.title} detail`} />
          </div>
        ) : null}

        {content?.description2 ? (
          <p className="Ornare p-0">{content.description2}</p>
        ) : null}
      </div>
    </div>
  );
};

export default Popup;
